module.exports = __webpack_public_path__ + "21d02b8e2ec5f54b5469fb788e4a0f.svg";